<template>
    <div class="conversion-box">
        <div class="conversion">
            <div class="form-box" v-loading="loading">
                <el-form>
                    <el-form-item label="产品">
                        <ListCheck :list="list" v-model="product" />
                    </el-form-item>
                </el-form>
                <div class="p10" style="border: 1px solid #DCDFE6;border-radius: 4px;">
                    <FormGroup 
                    ref="formGroup" 
                    :isQuickApp="isQuickApp"
                    :isHarmonyOS="isHarmonyOS"
                    :product="product" :rootFormData="rootFormData" v-model="productFormData"
                        :rules="rules" @updateFetch="updateFetch" :venus_list="venus_list"
                        :industry_list="industry_list" />
                </div>
            </div>
            <div class="footer">
                <el-button @click="handleCloseClick">取消</el-button>
                <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit"
                    :loading="saveLoaing">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import ListCheck from '@/views/marketingManagement/configuration/components/wkListCheck.vue';
import FormGroup from './formGroup.vue';
import _ from 'lodash';
import AsyncValidator from 'async-validator';
import {
    BatchIndustryInfoApi,
    BatchPromotionVenusApi,
    getProductInfoApi
} from '@/api/marketManage/configuration.js'
import { getBatchProductIconApi } from '@/api/marketManage/huaweiAds.js'
import { tipModal } from '@/views/marketingManagement/configuration/modal/index.js'
import { getMaterialInfoApi } from '@/api'
import { unHttp } from './unHttp.js'
let devalidator = (rule, value, callback) => {
    // 检查value是否以unHttp中的任意一个item开头
    let isFlag = unHttp.some(item => value?.startsWith(item));
    if (value && !isFlag) {
        callback(new Error("监测链接地址前缀错误"));
    } else {
        callback();
    }
}
let base_rules = (len, params)=>  {
    const isOS = params.product_type == 'HARMONYOS_NATIVE_APP'
    return {
        icon: [
            { required: true, type: 'string', message: '请上传图标', trigger: 'blur' },
            // 自定义判断图片后缀是不是 jpg jpeg png
            {
                validator: (rule, value, callback) => {
                    if (value) {
                        let suffix = value.split('.').pop();
                        if (['jpg', 'jpeg', 'png'].indexOf(suffix) === -1) {
                            callback(new Error('请上传 jpg jpeg png 格式的图片'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        title: [
            { required: true, type: 'string', message: '请输入标题', trigger: 'blur' },
            { min: 1, max: len, message: `标题长度在1-${len}个字符之间`, trigger: 'blur' },
            { pattern: /^[^|^<]{1,}$/, message: '标题不能包含特殊字符 ^ | <', trigger: 'blur' },
        ],
        description: [
            {  max: 24, message: '文案长度在0-24个字符之间', trigger: 'blur' },
            { pattern: /^[^|^<]{0,24}$/, message: '文案不能包含特殊字符 ^ | <', trigger: 'blur' },
        ],
        corporate: [
            { required: true, type: 'string', message: '请输入品牌名称', trigger: 'blur' },
            { min: 1, max: 7, message: '品牌名称长度在1-7个字符之间', trigger: 'blur' },
            { pattern: /^[^|^<]{1,7}$/, message: '品牌名称不能包含特殊字符 ^ | <', trigger: 'blur' },
        ],
        industry_id: [
            { required: true, type: 'string', message: '请选择创意行业', trigger: 'change', },
        ],
        industry_labels: [
            { required: true, type: 'array', message: '请选择创意标签', trigger: 'change' },
        ],
        impression_monitor_url: [
            { validator: devalidator, trigger: 'change' },
            // { pattern: /^https:\/\/.{1,3800}$/, message: '请输入以https://开头的URL地址，长度不超过3800个字符', trigger: 'blur' }
        ],
        click_monitor_url: [
            { validator: devalidator, trigger: 'change' },
        ]
    }
}

export default {
    name: 'WkProductConfig',
    components: {
        ListCheck,
        FormGroup
    },
    props: ['rootFormData', 'rootFormDataOptions', 'cbs', 'value'],
    data() {
        return {
            once: false,
            list: [],
            product: '',
            saveLoaing: false,
            loading: false,
            field: 'name',
            form: {
            },
            productFormData: {
                icon: '', //https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg
                title: '',                      //标题
                description: '',                //文案
                industry_id: '',                //创意行业
                industry_labels: '',            //创意标签  
                corporate: '',                    //品牌名称 
                landing_page_type: 'LANDING_PAGE_TYPE_USER_DEFINED',            //落地页链接类型，1：自定义落地页，2：维纳斯落地页
                landing_page_1: '',              //落地页链接
                landing_page_2: '',              //落地页链接类型，1：自定义落地页，2：维纳斯落地页
                deeplink: '',                 //应用直达链接
                impression_monitor_url: '',  //曝光监测链接
                click_monitor_url: '',  //点击监测链接
                // channel_package_id: '',       //渠道包ID
                channel_pkg_number: '',       //渠道包数量
            },
            rules: {},
            venus_list: [],
            industry_list: [],
            productInfo: [],
            text_length: 22,
        }
    },
    computed: {
        product_type() {
            return this.rootFormData['product_type']
        },
        isQuickApp() {
            return this.product_type == 'QUICK_APP'
        },
        isHarmonyOS() {
            return this.product_type == 'HARMONYOS_NATIVE_APP'
        },
        errors_rules() {
            return {
                industry_id: '创意行业',
                industry_labels: '创意标签',
                deeplink: '应用直达链接',
                deep_link_url: 'deeplink链接',
                landing_page_1: '自定义落地页',
                landing_page_2: '维纳斯落地页',
            }
        }
    },
    watch: {
        'product': {
            async handler(newVal, oldVal) {
                if (!newVal) return
                this.loading = true;
                const productInfo = _.keyBy(this.productInfo, 'product_id');
                console.log(1111, this.form[newVal]);
                this.productFormData = this.form[newVal] || {
                    icon: '',
                    title: '',                      //标题
                    description: '',                //文案
                    industry_id: '',                //创意行业
                    industry_labels: '',            //创意标签  
                    corporate: '',                    //品牌名称 
                    landing_page_type: 'LANDING_PAGE_TYPE_USER_DEFINED',            //落地页链接类型，1：自定义落地页，2：维纳斯落地页
                    landing_page_1: '',              //落地页链接
                    landing_page_2: '',              //落地页链接类型，1：自定义落地页，2：维纳斯落地页
                    deeplink: '',                 //应用直达链接
                    deep_link_url: productInfo[newVal]?.deep_link_url || '',                 //deep_link_url
                    impression_monitor_url: '',  //曝光监测链接
                    click_monitor_url: '',  //点击监测链接
                    // channel_package_id: '',       //渠道包ID
                    channel_pkg_number: '',       //渠道包数量
                };
                await this.getIcon(newVal); // 调用接口获取图标链接，传入产品ID作为参数，将获取到的图标链接赋值给productFormData.icon属性，同时更新form表单中的icon字段的值为新的图标链接。
                this.$nextTick(() => {
                    this.$refs.formGroup.resetForm();
                })
                this.loading = false;
            },
        },
        'productFormData': {
            handler(newVal, oldVal) {
                // if (_.isEmpty(newVal, oldVal)) return
                if (this.product) {
                    delete this.rules['landing_page_2']
                    delete this.rules['landing_page_1']
                    // product_type
                    if(!this.isQuickApp) {
                        if (newVal['landing_page_type'] == 'LANDING_PAGE_TYPE_USER_DEFINED') {
                        
                            this.$set(this.rules, 'landing_page_1', [
                                { required: true, message: '请输入自定义落地页链接地址', trigger: 'change' },
                                {
                                    pattern: /^(https?:\/\/|hap:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ;,.\/?%&=]*)?$/i,
                                    message: '请输入正确的自定义落地页链接地址',
                                    trigger: 'change'
                                }
                            ])
                        } else if (newVal['landing_page_type'] == 'LANDING_PAGE_TYPE_APP') {
                            
                            this.$set(this.rules, 'landing_page_2', [
                                { required: true, message: '请选择维纳斯落地页', trigger: 'change' },
                            ])
                        }
                    }
                    this.$set(this.form, this.product, newVal)
                    this.$nextTick(() => {
                        if (!this.once) {
                            this.$refs.formGroup.resetForm()
                            this.once = true
                        }
                    })
                }
            },
            deep: true
        }
    },
    mounted() {
        Promise.all([
            getMaterialInfoApi({
                plat_id: 10,
                display_type: this.rootFormData.creative_size_id.toString(),
                type: 'text'
            }),
            this.getInfo()
        ]).then(([ materialInfo ]) => {
            const [ { text_length  } ] = materialInfo.data;
            this.text_length = +text_length;
            const { app_id } = this.rootFormDataOptions;
            this.list = app_id
            let first_item = _.head(app_id);
            let keys = this.value && this.value.map(v => String(v.app_id));
            if (!_.isEmpty(this.value)) {
                let new_value = this.convertArrayToObject(this.value)
                this.list.forEach(item => {
                    if (keys.includes(item.value)) {
                        let new_item = { ...new_value[item.value] }
                        if(!this.isQuickApp) {
                            if (new_value[item.value].landing_page_type == 'LANDING_PAGE_TYPE_USER_DEFINED') {
                                new_item.landing_page_1 = new_value[item.value].landing_page;
                            } else if (new_value[item.value].landing_page_type == 'LANDING_PAGE_TYPE_APP') {
                                new_item.landing_page_2 = new_value[item.value].landing_page;
                            }
                        }
                        this.$set(this.form, item.value, new_item)
                    }
                })
                this.product = first_item?.value;
            } else {
                this.product = first_item?.value;
                const productInfo = _.keyBy(this.productInfo, 'product_id');
                this.$set(this.form, this.product, { ...this.productFormData, deep_link_url: productInfo[this.product]?.deep_link_url || '' })
            }
            let res_rules = this.rootFormData.product_type == 'ANDROID_APP'
                ? {
                    ...base_rules(this.text_length, this.rootFormData),
                    deeplink: [
                        // { required: true, message: '请输入应用直达链接', trigger: 'change' },
                        { pattern: /^https:\/\/[^@]{1,3800}$/, message: '请输入以https://开头的URL地址，长度不超过3800个字符，且不能包含@字符', trigger: 'change' }
                    ]
                }
                : {
                    ...base_rules(this.text_length, this.rootFormData),
                     deep_link_url: [
                        { required: true, message: '请输入deeplink链接', trigger: 'change' },
                    ]
                };
            this.$set(this, 'rules', res_rules)

            // this.getIcon(first_item?.value);
        })
    },
    methods: {
        getIcon(newVal) {
            if (this.form[newVal]?.icon) return;
            this.loading = true;
            getBatchProductIconApi({ plat_id: 10, product_id: newVal, account_id: this.rootFormData?.account_id }).then(res => {
                if (res.code == 200) {
                    this.$set(this.form, newVal, { ...this.form[newVal], icon: res.data.label })
                    this.$set(this.productFormData, 'icon', res.data.label)
                }
            }).finally(() => {
                this.loading = false;
            })
        },
        updateFetch(type) {
            if (type === 'venus_list') {
                BatchPromotionVenusApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 10,
                    search: ''
                }).then(res => {
                    this.venus_list = res.data.list;
                })
            }
        },
        handleCloseClick() {
            this.$emit('close')
        },
        // validateAll() {
        //     const descriptor = {};
        //     const current_keys = Object.keys(this.productFormData);
        //     current_keys.forEach(key => {
        //         descriptor[key] = this.rules[key];
        //     })
        //     const validator = new AsyncValidator(this.descriptor);
        // },
        getInfo() {
            this.loading = true;
            return Promise.all([
                BatchIndustryInfoApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 10,
                }),
                BatchPromotionVenusApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 10,
                    search: ''
                }),
                getProductInfoApi({
                     plat_id: 10,
                     product_id: (this.rootFormData.app_id || []).toString()
                }).catch(()=> ({}))
            ]).then(([indestry_res, venus_res, product_res]) => {
                this.productInfo = product_res.data?.list || [];
                console.log('API 请求成功:', indestry_res, venus_res);
                if (indestry_res.code == 200 && venus_res.code == 200) {
                    this.industry_list = indestry_res.data.list;
                    this.venus_list = venus_res.data.list;
                    return Promise.resolve();
                } else {
                    return Promise.reject(new Error('API 请求返回非 200 状态码'));
                }
            }).catch((error) => {
                return Promise.reject(error);
            }).finally(() => {
                this.loading = false;
            })
        },
        convertAppData(data) {
            return Object.entries(data).map(([app_id, appInfo]) => ({
                app_id,
                icon: appInfo.icon,
                title: appInfo.title,
                description: appInfo.description,
                industry_id: appInfo.industry_id,
                industry_labels: appInfo.industry_labels,
                corporate: appInfo.corporate,
                landing_page_type: appInfo.landing_page_type,
                deeplink: appInfo.deeplink,
                deep_link_url: appInfo.deep_link_url,
                impression_monitor_url: appInfo.impression_monitor_url,
                click_monitor_url: appInfo.click_monitor_url,
                channel_pkg_number: appInfo.channel_pkg_number,
                landing_page: appInfo.landing_page
            }));
        },
        convertArrayToObject(array) {
            return array.reduce((acc, item) => {
                const { app_id, ...rest } = item;
                acc[app_id] = rest;
                return acc;
            }, {});
        },
        onSubmit: async function () {
            this.$refs.formGroup.submitForm()
            // const validator = new AsyncValidator(this.rules);
            const newForm = _.cloneDeep(this.form);
            console.log('newForm:', newForm, this.list);
            let promiseList = [];
            _.forEach(newForm, (item, key) => {
                let descriptor = {};
                let landing_page_1 = []
                let landing_page_2 = []
                let res_rules =  {
                    ...base_rules(this.text_length, this.rootFormData),
                    deeplink: [
                        // { required: true, message: '请输入应用直达链接', trigger: 'change' },
                        { pattern: /^https:\/\/[^@]{1,3800}$/, message: '请输入以https://开头的URL地址，长度不超过3800个字符，且不能包含@字符', trigger: 'change' }
                    ],
                };
                if(!this.isQuickApp) { 
                    if (item['landing_page_type'] == 'LANDING_PAGE_TYPE_USER_DEFINED') {
                        landing_page_1 = [
                            { required: true, message: '请输入自定义落地页链接地址', trigger: 'blur' },
                            {
                                pattern: /^(https?:\/\/|hap:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ;,.\/?%&=]*)?$/i,
                                message: '请输入正确的自定义落地页链接地址',
                                trigger: 'blur'
                            }
                        ];
                    } else if (item['landing_page_type'] == 'LANDING_PAGE_TYPE_APP') {
                        landing_page_2 = [
                            { required: true, message: '请选择维纳斯落地页', trigger: 'change' },
                        ]
                    }
                    if (landing_page_1.length > 0) {
                        descriptor = { ...res_rules, ...{ landing_page_1: landing_page_1 } };
                    } else if (landing_page_2.length > 0) {
                        descriptor = { ...res_rules, ...{ landing_page_2: landing_page_2 } };
                    }
                }else {
                    descriptor = { ...res_rules , deep_link_url: [
                        { required: true, message: '请输入deeplink链接', trigger: 'change' },
                    ]}
                }
                const validator = new AsyncValidator(descriptor);

                promiseList.push(new Promise((resolve, reject) => {
                    validator.validate(item, (errors, fields) => {
                        if (errors) {
                            // console.log('验证失败-errors:', errors, fields);
                            let error_names = Object.keys(this.errors_rules);
                            let reset_errors = errors.map((item) => {
                                let new_item = { ...item };
                                if (error_names.includes(item.field)) {
                                    new_item.label = this.errors_rules[item.field];
                                }
                                return new_item;
                            })
                            let label_list = _.filter(this.list, (v) => { return v.value == key })
                            let res_errors = {
                                label: _.head(label_list).label,
                                value: key,
                                errors: reset_errors
                            }
                            reject(res_errors);
                        } else {
                            resolve();
                        }
                    })
                }))
            })

            try {
                this.saveLoaing = true;
                const results = await Promise.allSettled(promiseList);
                const invalidResults = results.filter(result => result.status === 'rejected');

                let newFormKeys = Object.keys(newForm)
                let emptyForm = this.list.filter(v => !newFormKeys.includes(v.value)).map(v => v.app_name)
                console.log('emptyForm:', emptyForm, invalidResults);
                if (invalidResults.length > 0 || emptyForm.length > 0) {
                    const allErrors = invalidResults.flatMap(result => result.reason);
                    let tipErrors = allErrors.map(v => v.label)
                    let errorObjMsg = {
                        '': _.uniq([...tipErrors, ...emptyForm])
                    };
                    tipModal({
                        props: {
                            tip: '存在未通过校验的产品，请检查，具体如下：',
                            list: errorObjMsg
                        },
                    })
                } else {
                    console.log('所有表单验证通过');
                    // 在这里执行表单提交逻辑 对this.form 进行操作，根据 landing_page_type 进行不同的处理 1 把 landing_page_1 赋值给 landing_page, 2 把 landing_page_2 赋值给 landing_page,并且过滤掉landing_page_1与landing_page_2
                    _.forEach(newForm, (item) => {
                        if (item.landing_page_type == 'LANDING_PAGE_TYPE_USER_DEFINED') {
                            item.landing_page = item.landing_page_1;
                        } else if (item.landing_page_type == 'LANDING_PAGE_TYPE_APP') {
                            item.landing_page = item.landing_page_2;
                        }
                        // 过滤掉 landing_page_1 和 landing_page_2
                        delete item.landing_page_1;
                        delete item.landing_page_2;
                    });
                    // 可以在这里使用新数据进行提交操作
                    console.log('处理后的新数据:', newForm);
                    let newFormData = this.convertAppData(newForm)
                    console.log('处理后的新数据1:', newFormData);
                    this.cbs.onSubmit(newFormData)
                }
            } catch (error) {
                console.log('执行验证时出错:', error);
            } finally {
                this.saveLoaing = false;
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.tip-icon {
    font-size: 18px;
    margin-right: 4px;
}

.conversion-box {
    height: 100%;
    width: 100%;
    overflow-x: auto;
}

.conversion {
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 1200px;

    .tip {
        margin-bottom: 10px;
    }

    .form-box {
        height: 0;
        flex: 1;
        overflow: auto;
        // background: red;
        margin-top: 16px;
    }

    .footer {
        height: 60px;
        line-height: 60px;
        text-align: right;
        padding-right: 80px;
        margin: 0 -20px;
        box-shadow: 4px 0 4px #ccc;
    }
}
</style>